//noinspection JSUnusedGlobalSymbols
//noinspection JSUnusedLocalSymbols

/**
 * ESA Component: Content Controller Blueprint
 * -------------------------------------------------------------
 * @copyright (c) 2024 [Paul Höcker|PHMG](https://phmg.online). All rights reserved.
 * @license   GNU General Public License version 3 or later
 * @version   1.0.0, 2024-01-01 00:00
 */

import Controller from "@phmg/com_hive/src/js/exports/Controller.js"

class ContentControllerBlueprint extends Controller {
  static CID = 'content-blueprint'
  static NAME = 'Content Blueprint'

  contentName = 'content'

  callHandler
  formHandler

  modalElement
  displayElement
  formElement

  initiate() {
    super.initiate();

    // Check display and form element
    this.displayElement = document.querySelector(`[data-container="${this.contentName}"]`);
    this.formElement = document.querySelector(`[data-container="${this.contentName}.edit"]`);
    if (!this.displayElement && !this.formElement) {
      this.utils.idb() && console.log(`${this.contentName} container not found`)
      return;
    }

    // Check modal element
    this.modalElement = document.getElementById(`${this.contentName}-modal`)
    !this.modalElement && this.utils.odb(`${this.contentName} modal not found`, this)
    if (this.modalElement) {
      this.modalElement.addEventListener('hide.bs.modal', () => this.displayElement.focus())
    }

    // Initiate the call handler and form handler
    const controller = this;
    //const CallHandlerClass = Hive.getCallHandler();
    //const FormHandlerClass = Hive.getFormHandler();
    const basePath = Joomla.getOptions('system.paths', {})['base'] || '';
    const baseUrl = this.formElement ? this.formElement.action : basePath + '/index.php?option=com_esa&format=json';
    this.callHandler = window.Hive.getCallHandler(controller, baseUrl);
    if (this.formElement) {
      this.formHandler = window.Hive.getFormHandler(controller, this.formElement);
      this.formHandler.preventSubmit(true);
    }

    if (this.displayElement) {

      // When clicking on one of the edit buttons
      this.displayElement.addEventListener('click', (e) => {
        const { target } = e;
        const button = target.closest('button[data-get]');
        if (button) {
          let request = button.dataset.get;
          let requestData = this.onPrepareRequest(
            this.callHandler.prepareData(
              button.dataset,
              { request : request, id : 0, }
            )
          );

          this.callHandler.getRequest('api.get',
            requestData,
            (success, response) => {
              success = this.onLoadForm(success, response);
              if (success) {
                if (typeof response.html === 'string') {
                  this.utils.replaceElement(`[data-content="${this.contentName}.edit"]`, response.html);
                  // Remove any previous loading display
                  this.formHandler && this.formHandler.freeFrom(true);
                  // Show the modal if it exists
                  this.modalElement && this.utils.getBsBridge()('modal.show', this.modalElement);
                } else {
                  this.display();
                }
              }
            })
        }
      })
    }


    if (this.formHandler && this.modalElement) {

      // When clicking on the submit button from the modal
      this.modalElement.addEventListener('click', (e) => {
        const { target } = e;
        const button = target.closest('button[data-task]');
        if (button) {
          let request = button.dataset.task;
          let formData = this.formHandler.getData();
          formData.append('request', request);
          this.formHandler.lockForm();
          this.callHandler.set(false).postRequest('api.post', formData,
            (success, response) => {
              success = this.onSubmitForm(success, response);
              this.formHandler.freeFrom(success);
              if (success) {
                this.utils.getBsBridge()('modal.hide', this.modalElement);
                this.display();
              }
            })
        }
      })

    }
  }

  /**
   * Display / update the contents display
   */
  display() {
    let requestData = { 'request' : `${this.contentName}.display` }

    this.callHandler.getRequest('api.get',
      this.onPrepareRequest(requestData),
      (success, response) => {
        success = this.onDisplayContent(success, response);
        if (success && typeof response.html === 'string') {
          this.utils.replaceElement(`[data-content="${this.contentName}"]`, response.html);
        }

      })
  }

  /**
   * On build request
   * @param {object} requestData
   * @returns {object}
   */
  onPrepareRequest(requestData) {
    requestData = requestData || {};

    // Add the id of the main content
    let viewName = this.context['view'] || '';
    requestData[`${viewName}_id`] = this.context['id'] || 0;

    return requestData;
  }

  /**
   * On load form
   * @param {boolean} success
   * @param {*} response
   */
  onLoadForm(success, response) {
    this.utils.idb() && console.log('onLoadForm');

    return success;
  }

  /**
   * On submit form
   * @param {boolean} success
   * @param {*} response
   */
  onSubmitForm(success, response) {
    this.utils.idb() && console.log('onSubmitForm');

    return success;
  }

  /**
   * On display content
   * @param {boolean} success
   * @param {*} response
   */
  onDisplayContent(success, response) {
    this.utils.idb() && console.log('onDisplayContent');

    return success;
  }


}

export default ContentControllerBlueprint
